// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.7.12_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.11.0_@rspack+core@1.7.12_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.branding-color-palette {
  margin-bottom: -12px;
}
.branding-color-palette .color-list {
  list-style: none;
  padding: 4px 0 0 0;
  display: flex;
  flex-wrap: wrap;
}
.branding-color-palette .color-list li {
  position: relative;
  margin-right: 12px;
  margin-bottom: 12px;
}
.branding-color-palette .color-list .color-display {
  display: flex;
  flex-direction: column;
}
.branding-color-palette .color-list .color-display .preview {
  width: 48px;
  height: 48px;
  border-radius: 8px;
}
.branding-color-palette .color-list .color-display .text {
  margin-top: 8px;
  margin-left: 0;
  font-size: 12px;
  opacity: 0.6;
}
.branding-color-palette .color-list .delete {
  position: absolute;
  top: -4px;
  right: -4px;
  height: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: black;
  color: white;
  width: 18px;
  border-radius: 50%;
  font-size: 10px;
}
.branding-color-palette .color-list .add {
  width: 48px;
  height: 48px;
  border-radius: 8px;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
}
.branding-color-palette .nkl-form-vertical label {
  display: flex;
  width: 100%;
}
.branding-color-palette .nkl-form-vertical label .fallback-tag-container {
  margin-left: auto;
}
.branding-color-palette .nkl-form-vertical label .fallback-tag {
  margin: 0;
}
.branding-color-palette.compact .color-list .color-display .preview {
  width: 24px;
  height: 24px;
  border-radius: 4px;
}
.branding-color-palette.compact .color-list .color-display .text {
  display: none;
}
.branding-color-palette.compact .color-list li {
  margin-right: 6px;
  margin-bottom: 6px;
}
.branding-color-palette.compact .color-list .delete {
  top: -2px;
  right: -2px;
  height: 13px;
  width: 13px;
  font-size: 7px;
}
.branding-color-palette.compact .color-list .add {
  width: 24px;
  height: 24px;
  border-radius: 4px;
  font-size: 12px;
}
.branding-color-picker-input {
  display: flex;
  padding: 8px 0;
}
.branding-color-picker-input .color-display {
  width: 32px;
  height: 32px;
  flex-shrink: 0;
  margin-left: 12px;
}
.branding-color-picker-input .color-display .preview {
  background-color: rgba(0, 0, 0, 0);
  width: 100%;
  height: 100%;
  border-radius: 6px;
  border-color: #d9d9d9;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
